<div class="col">
    <div class="card" style="width: 100%">
        <div class="card-body">
            <div class="wrapper">
                <img class="card-img-top" src="/assets/images/confirmation.svg" alt="Card image cap">
                <h5 class="card-title">{{this.lables(this.getPageName()).lable}}</h5>
                <button (click)="this.goToLogin()" class="btn btn-primary doneBtn">{{this.lables(this.getPageName()).doneBtn}}</button>
            </div>
        </div>
    </div>
</div>
<router-outlet></router-outlet>